var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.entry.camount)?_c('div',{staticClass:"item__line"},[_c('b',[_vm._v(_vm._s(_vm.entry.label)+": ")]),_c('TendenceIcons',{attrs:{"tendence":_vm.entry.camount,"tendency-colors":_vm.tendencyColors}}),_c('br'),_vm._v(" "+_vm._s(_vm.entry.ccount)+_vm._s(_vm.ctendency)+". Tendenz: "+_vm._s(_vm.entry.camount)+" ")],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }